// No imports: the candidate builds load this module too.

/**
 * Runs `task` once the page is idle, or after `idleTimeoutMs` on a page that never goes idle.
 * Without requestIdleCallback (WebKit: Safari and every iOS browser) it runs after
 * `fallbackDelayMs` instead. Returns a function that cancels a task that has not started yet.
 */
export function runWhenIdle(
  task: () => void,
  opts: { idleTimeoutMs: number; fallbackDelayMs: number }
): () => void {
  if (typeof window.requestIdleCallback === 'function') {
    const handle = window.requestIdleCallback(task, {
      timeout: opts.idleTimeoutMs,
    });
    return () => window.cancelIdleCallback(handle);
  }
  const handle = window.setTimeout(task, opts.fallbackDelayMs);
  return () => window.clearTimeout(handle);
}
